import { Capacitor } from '@capacitor/core';
import { useEffect } from 'react';
import { shareTokenFromAppUrl } from '../lib/community-packs.js';
import { MARKETPLACE_URL } from '../services/api.js';
import { usePendingShareStore } from '../state/pending-share-store.js';

/**
 * In the native shells, a tapped marketplace share link opens the app (universal link / app link). The link's token is remembered in memory
 * and `onOpen` takes the person to where the pack is added (Home, whose Card pack picker pre-fills the add form). Nothing is added by the link
 * itself: a grown-up still presses Add (behind the gate in the kids edition). Off when the marketplace is not configured, and a no-op on the web.
 */
export function useShareLinkOpen(onOpen: () => void): void {
  useEffect(() => {
    if (MARKETPLACE_URL === '' || !Capacitor.isNativePlatform()) return;
    let remove: (() => void) | undefined;
    let cancelled = false;
    void import('@capacitor/app').then(({ App }) =>
      App.addListener('appUrlOpen', (event) => {
        const token = shareTokenFromAppUrl(event.url, MARKETPLACE_URL);
        if (!token) return;
        usePendingShareStore.getState().set(token);
        onOpen();
      }).then((handle) => {
        if (cancelled) void handle.remove();
        else remove = () => void handle.remove();
      }),
    );
    return () => {
      cancelled = true;
      remove?.();
    };
  }, [onOpen]);
}
